/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StepConstraintDto } from './StepConstraintDto';
import {
    StepConstraintDtoFromJSON,
    StepConstraintDtoFromJSONTyped,
    StepConstraintDtoToJSON,
    StepConstraintDtoToJSONTyped,
} from './StepConstraintDto';
import type { PossibleAnswerDto } from './PossibleAnswerDto';
import {
    PossibleAnswerDtoFromJSON,
    PossibleAnswerDtoFromJSONTyped,
    PossibleAnswerDtoToJSON,
    PossibleAnswerDtoToJSONTyped,
} from './PossibleAnswerDto';

/**
 * 
 * @export
 * @interface QuestionDetailDto
 */
export interface QuestionDetailDto {
    /**
     * Question unique identifier
     * @type {string}
     * @memberof QuestionDetailDto
     */
    id?: string;
    /**
     * Parent questionnaire ID
     * @type {string}
     * @memberof QuestionDetailDto
     */
    questionnaireId?: string;
    /**
     * Question key/code
     * @type {string}
     * @memberof QuestionDetailDto
     */
    key?: string;
    /**
     * Question label/text
     * @type {string}
     * @memberof QuestionDetailDto
     */
    label?: string;
    /**
     * Question type code
     * @type {string}
     * @memberof QuestionDetailDto
     */
    questionTypeCode?: string;
    /**
     * Question type label
     * @type {string}
     * @memberof QuestionDetailDto
     */
    questionTypeLabel?: string;
    /**
     * Step number in the questionnaire
     * @type {number}
     * @memberof QuestionDetailDto
     */
    step?: number | null;
    /**
     * Display order of the question
     * @type {number}
     * @memberof QuestionDetailDto
     */
    displayOrder?: number;
    /**
     * Icon key for the question
     * @type {string}
     * @memberof QuestionDetailDto
     */
    iconKey?: string | null;
    /**
     * Group title for question grouping
     * @type {string}
     * @memberof QuestionDetailDto
     */
    groupTitle?: string | null;
    /**
     * Whether the question is required
     * @type {boolean}
     * @memberof QuestionDetailDto
     */
    isRequired?: boolean;
    /**
     * Dependencies for this question
     * @type {Array<StepConstraintDto>}
     * @memberof QuestionDetailDto
     */
    dependsOn?: Array<StepConstraintDto>;
    /**
     * Constraints applied to this question
     * @type {Array<StepConstraintDto>}
     * @memberof QuestionDetailDto
     */
    constraints?: Array<StepConstraintDto>;
    /**
     * Conditions to skip this question
     * @type {Array<StepConstraintDto>}
     * @memberof QuestionDetailDto
     */
    skipIf?: Array<StepConstraintDto>;
    /**
     * Possible answers for the question
     * @type {Array<PossibleAnswerDto>}
     * @memberof QuestionDetailDto
     */
    possibleAnswers?: Array<PossibleAnswerDto>;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof QuestionDetailDto
     */
    creationTime?: Date;
    /**
     * Last modification timestamp
     * @type {Date}
     * @memberof QuestionDetailDto
     */
    lastModificationTime?: Date | null;
    /**
     * Username of the creator
     * @type {string}
     * @memberof QuestionDetailDto
     */
    creatorUserName?: string | null;
}

/**
 * Check if a given object implements the QuestionDetailDto interface.
 */
export function instanceOfQuestionDetailDto(value: object): value is QuestionDetailDto {
    return true;
}

export function QuestionDetailDtoFromJSON(json: any): QuestionDetailDto {
    return QuestionDetailDtoFromJSONTyped(json, false);
}

export function QuestionDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'questionnaireId': json['questionnaireId'] == null ? undefined : json['questionnaireId'],
        'key': json['key'] == null ? undefined : json['key'],
        'label': json['label'] == null ? undefined : json['label'],
        'questionTypeCode': json['questionTypeCode'] == null ? undefined : json['questionTypeCode'],
        'questionTypeLabel': json['questionTypeLabel'] == null ? undefined : json['questionTypeLabel'],
        'step': json['step'] == null ? undefined : json['step'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
        'groupTitle': json['groupTitle'] == null ? undefined : json['groupTitle'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'dependsOn': json['dependsOn'] == null ? undefined : ((json['dependsOn'] as Array<any>).map(StepConstraintDtoFromJSON)),
        'constraints': json['constraints'] == null ? undefined : ((json['constraints'] as Array<any>).map(StepConstraintDtoFromJSON)),
        'skipIf': json['skipIf'] == null ? undefined : ((json['skipIf'] as Array<any>).map(StepConstraintDtoFromJSON)),
        'possibleAnswers': json['possibleAnswers'] == null ? undefined : ((json['possibleAnswers'] as Array<any>).map(PossibleAnswerDtoFromJSON)),
        'creationTime': json['creationTime'] == null ? undefined : (new Date(json['creationTime'])),
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : (new Date(json['lastModificationTime'])),
        'creatorUserName': json['creatorUserName'] == null ? undefined : json['creatorUserName'],
    };
}

export function QuestionDetailDtoToJSON(json: any): QuestionDetailDto {
    return QuestionDetailDtoToJSONTyped(json, false);
}

export function QuestionDetailDtoToJSONTyped(value?: QuestionDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'questionnaireId': value['questionnaireId'],
        'key': value['key'],
        'label': value['label'],
        'questionTypeCode': value['questionTypeCode'],
        'questionTypeLabel': value['questionTypeLabel'],
        'step': value['step'],
        'displayOrder': value['displayOrder'],
        'iconKey': value['iconKey'],
        'groupTitle': value['groupTitle'],
        'isRequired': value['isRequired'],
        'dependsOn': value['dependsOn'] == null ? undefined : ((value['dependsOn'] as Array<any>).map(StepConstraintDtoToJSON)),
        'constraints': value['constraints'] == null ? undefined : ((value['constraints'] as Array<any>).map(StepConstraintDtoToJSON)),
        'skipIf': value['skipIf'] == null ? undefined : ((value['skipIf'] as Array<any>).map(StepConstraintDtoToJSON)),
        'possibleAnswers': value['possibleAnswers'] == null ? undefined : ((value['possibleAnswers'] as Array<any>).map(PossibleAnswerDtoToJSON)),
        'creationTime': value['creationTime'] == null ? undefined : ((value['creationTime']).toISOString()),
        'lastModificationTime': value['lastModificationTime'] == null ? undefined : ((value['lastModificationTime'] as any).toISOString()),
        'creatorUserName': value['creatorUserName'],
    };
}

